require('./details-animation');
import Splide from '@splidejs/splide';

import { klaroConfig } from './klaro-config';
import * as klaro from 'klaro';

// Klaro
klaro.render(klaroConfig);
document.querySelectorAll('[data-klaro-service]').forEach(el => {
  el.addEventListener('click', e => {
    klaro.getManager(klaroConfig).updateConsent(el.dataset.klaroService, true);
    klaro.getManager(klaroConfig).saveAndApplyConsents();
  });
});
document.querySelectorAll('[data-klaro-settings]').forEach(el => {
  el.addEventListener('click', e => {
    klaro.show(klaroConfig);
    e.preventDefault();
  });
});

// Site-Nav, Toggle
let siteNav = document.querySelector('.site-nav');
let siteNavToggle = document.querySelector('.site-nav__toggle');
let siteNavClose = document.querySelector('.site-nav__close');
function setSiteNavExpanded(expanded) {
  siteNav.setAttribute('aria-expanded', expanded);
  siteNavToggle.setAttribute('aria-expanded', expanded);
  if(expanded === 'true') {
    siteNav.focus();
  }
}
if(siteNav && siteNavToggle && siteNavClose) {
  setSiteNavExpanded('false');
  siteNavToggle.addEventListener('click', e => {
    if(siteNav.getAttribute('aria-expanded') === 'false') {
      setSiteNavExpanded('true');
    } else {
      setSiteNavExpanded('false');
    }
  });
  siteNavClose.addEventListener('click', e => {
    setSiteNavExpanded('false');
  });
  siteNav.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', e => {
      setSiteNavExpanded('false');
    });
  });
}

// Splide
Splide.defaults = {
  i18n: {
		prev: 'Vorheriges Slide',
		next: 'Nächstes Slide',
    slideX: 'Gehe zu Slide %s',
    pageX: 'Gehe zu Seite %s',
    select: 'Wähle eine Seite zum Anzeigen',
    slide: 'Slide',
    slideLabel: '%s von %s',
    carousel: 'Slider'
  },
};

// Splide, Artikel, Team
// document.querySelectorAll('.articles-team').forEach(splide => {
//   new Splide(splide, {
//     arrows: false,
//     pagination: true,
//     gap: '1rem',
//     perPage: 4,
//     breakpoints: {
//       1200: {
//         perPage: 3
//       },
//       768: {
//         perPage: 2
//       },
//       480: {
//         perPage: 1
//       }
//     }
//   }).mount();
// });

// Splide, Artikel, Team, Arzthelfer
document.querySelectorAll('.articles-team__category:nth-of-type(2)').forEach(splide => {
  splide.classList.add('splide');

  let track = splide.querySelector('.articles-team__track');
  let list = splide.querySelector('.articles-team__list');
  let slides = splide.querySelectorAll('.articles-team__slide');
  if(!track || !list || !slides) return;

  track.classList.add('splide__track');
  list.classList.add('splide__list');
  slides.forEach(slide => {
    slide.classList.add('splide__slide');
  })

  new Splide(splide, {
    arrows: false,
    pagination: true,
    gap: '1rem',
    perPage: 3,
    breakpoints: {
      // 1200: {
      //   perPage: 3
      // },
      768: {
        perPage: 2
      },
      480: {
        perPage: 1
      }
    }
  }).mount();
});


// Splide, Gallery, Splide
document.querySelectorAll('.gallery').forEach(splide => {
  new Splide(splide, {
    arrows: false,
    pagination: false,
    gap: '1rem',
    perPage: 3,
    breakpoints: {
      768: {
        perPage: 2
      },
      480: {
        perPage: 1
      }
    }
  }).mount();
});

// E-Mail-Links
document.querySelectorAll('.link-email[data-alias][data-domain]').forEach(linkPlaceholder => {
  let email = linkPlaceholder.dataset.alias + '@' + linkPlaceholder.dataset.domain;
  let a = document.createElement('a');
  a.href = "mailto:" + email;
  a.innerText = email;
  linkPlaceholder.replaceWith(a);
});